// Tutor app: 10 students — names + IDs ONLY. No scores. No pre-filled data.
export const STUDENTS = [
  { id: 'student_aarav',  name: 'Aarav Shah' },
  { id: 'student_diya',   name: 'Diya Mehta' },
  { id: 'student_rohan',  name: 'Rohan Patel' },
  { id: 'student_sneha',  name: 'Sneha Joshi' },
  { id: 'student_kabir',  name: 'Kabir Verma' },
  { id: 'student_priya',  name: 'Priya Nair' },
  { id: 'student_arjun',  name: 'Arjun Sharma' },
  { id: 'student_meera',  name: 'Meera Iyer' },
  { id: 'student_dev',    name: 'Dev Kapoor' },
  { id: 'student_anika',  name: 'Anika Singh' },
];
